import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar'
import { ProfileDropdown } from '@/components/layout/profileDropdown'
import { useFullScreen } from '@/hooks/useFullscreen'
import { useUtcSwitcher } from '@/hooks/useUtcSwitcher'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip'
import { ModeToggle } from '@/components/layout/modeToggle'
import { Globe, MapPin, Maximize, Menu, Minimize } from 'lucide-react'

const Header = () => {
  const { toggleSidebar } = useSidebar()
  const { isFullScreen, toggleFullscreen } = useFullScreen()
  const { isUtc, toggleUtc } = useUtcSwitcher()

  const handleSidebarTogglerClick = () => toggleSidebar()

  const handleFullScreenTogglerClick = () => {
    toggleFullscreen()
  }

  const handleUtcSwitcherClick = () => toggleUtc()

  return (
    <header className="flex justify-between pl-2 md:pr-6 py-2 border-b shadow-sm">
      <Button variant="outline" size="icon" onClick={handleSidebarTogglerClick}>
        <Menu />
      </Button>
      <div className="flex items-center gap-4">
        <div className="flex gap-2 items-center">
          <Button variant="ghost" size="icon" onClick={handleFullScreenTogglerClick}>
            {isFullScreen ? <Minimize /> : <Maximize />}
          </Button>
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" onClick={handleUtcSwitcherClick}>
                  {isUtc ? <Globe /> : <MapPin />}
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{isUtc ? 'UTC Time' : 'Local Time'}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          <ModeToggle />
        </div>
        <ProfileDropdown />
      </div>
    </header>
  )
}

export { Header }
